module.exports = __webpack_public_path__ + "static/pickup-71ce235d2499fce747c0bdeee7499f01.png";